// Based on https://github.com/pmndrs/drei/blob/v9.88.17/src/materials/DiscardMaterial.tsx
import { shaderMaterial } from "./shaderMaterial";

export const DiscardMaterial = /* @__PURE__ */ shaderMaterial(
  {},
  'void main() { }',
  'void main() { gl_FragColor = vec4(0.0, 0.0, 0.0, 0.0); discard;  }'
)